/* SSS ARMA v1: storefront declaration with mandatory staff review, not server-side enforcement. */
(() => {
  'use strict';
  if (window.SSSArma) return;
  const FEE_PRODUCT_ID = 8411505983551;
  const root = window.Shopify?.routes?.root || '/';
  const nativeFetch = window.fetch.bind(window);
  let queue = Promise.resolve(), pendingChoice = null, latest = null;
  document.documentElement.classList.add('sss-arma-on');
  const dialog = document.getElementById('sss-arma-dialog');
  const form = document.getElementById('sss-arma-form');
  let checkoutMode = false;
  function report(error) {
    if (!checkoutMode) return; // No storefront toast; checkout owns all feedback.
    const message = document.getElementById('sss-arma-error');
    message.textContent = error.message || 'Unable to verify the fee. Please try again or contact us.';
    message.hidden = false;
    if (!dialog.open) dialog.showModal();
  }
  function serial(task) {
    const result = queue.then(task);
    queue = result.catch(() => {});
    return result;
  }
  async function json(path, body) {
    const response = await nativeFetch(root + path, {
      credentials: 'same-origin', cache: 'no-store',
      ...(body ? {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify(body)} : {})
    });
    if (!response.ok) throw new Error('Unable to update the recycling fee. Please try again or contact us before checkout.');
    return response.json();
  }
  async function read() {
    const response = await nativeFetch(root + 'cart?section_id=sss-arma-cart&t=' + Date.now(), {credentials:'same-origin', cache:'no-store'});
    if (!response.ok) throw new Error('Unable to verify the recycling fee. Please try again.');
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    const data = doc.querySelector('[data-sss-arma-cart]');
    if (!data) throw new Error('Recycling fee setup is unavailable. Please contact us before checkout.');
    return JSON.parse(data.textContent);
  }
  function countPanels(data) {
    let total = 0;
    for (const item of data.items) {
      if (item.productId === FEE_PRODUCT_ID) continue;
      if (String(item.type).trim().toLowerCase() !== 'solar panel') continue;
      const missingDimension = value => value == null ||
        (typeof value === 'string' && value.trim() === '') || Number(value) === 0;
      // Store policy: either missing/blank/zero dimension qualifies by default.
      const defaultEligible = missingDimension(item.length) || missingDimension(item.width);
      if (!defaultEligible) {
        const length = Number(item.length), width = Number(item.width);
        if (!Number.isFinite(length) || !Number.isFinite(width) || length < 0 || width < 0)
          throw new Error('Panel dimensions need confirmation. Please contact us so we can complete your order.');
        // Source fields are decimal inches; one square inch = 0.00064516 m².
        if (length * width * 0.00064516 < 1 - 1e-12) continue;
      }
      if (item.count == null && /pallet|bundle|pack of/i.test(item.title))
        throw new Error('The number of panels in this pack needs confirmation. Please contact us.');
      const perUnit = item.count == null ? 1 : Number(item.count);
      if (!Number.isSafeInteger(perUnit) || perUnit < 1 || !Number.isSafeInteger(item.quantity) || item.quantity < 0)
        throw new Error('A product needs its recycling panel count reviewed. Please contact us.');
      total += perUnit * item.quantity;
      if (!Number.isSafeInteger(total)) throw new Error('Please contact us to arrange this panel order.');
    }
    return total;
  }
  function ask(current) {
    if (pendingChoice) return pendingChoice.promise;
    let finish;
    const promise = new Promise(resolve => { finish = resolve; });
    const previous = document.activeElement;
    pendingChoice = {promise, finish, previous};
    form.reset();
    for (const input of form.elements.arma_destination) input.checked = input.value === current;
    document.getElementById('sss-arma-error').hidden = true;
    dialog.showModal();
    form.querySelector('input').focus();
    return promise;
  }
  function closeChoice(value) {
    const active = pendingChoice;
    pendingChoice = null;
    if (!value) dialog.close();
    if (!value) active?.previous?.focus?.();
    active?.finish(value);
  }
  form.addEventListener('submit', event => {
    event.preventDefault();
    if (!form.reportValidity()) return;
    if (pendingChoice) {
      closeChoice(new FormData(form).get('arma_destination'));
      document.getElementById('sss-arma-confirm').disabled = true;
      document.getElementById('sss-arma-confirm').textContent = 'Checking your order…';
    }
    else if (!checkingOut) checkout(new FormData(form).get('arma_destination')); 
  });
  dialog.addEventListener('cancel', event => {event.preventDefault(); if (!checkingOut || pendingChoice) closeChoice(null);});
  dialog.querySelector('[data-sss-arma-close]').addEventListener('click', () => { if (!checkingOut || pendingChoice) closeChoice(null); });
  function paint() {
    if (!latest) return;
    const text = latest.count ? (latest.choice === 'alberta' ? 'Alberta delivery / pickup · ' + latest.count + ' eligible panel(s). Recycling fee applied.' : latest.choice === 'outside' ? 'Delivery outside Alberta · fee exclusion subject to staff verification.' : 'Please choose where you will receive your panels.') : 'No eligible panels in this cart.';
    document.querySelectorAll('[data-sss-arma-status]').forEach(el => {el.textContent = text;});
    document.querySelectorAll('[data-sss-arma-change]').forEach(el => {el.hidden = !latest.count;});
  }
  function refresh(changed = true) {
    if (changed && window.theme?.pageType === 'cart') { window.location.reload(); return; }
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    paint();
  }
  async function sync(forceChoice = false, selectedChoice = null, changeChoice = false) {
    let data = await read();
    document.querySelectorAll("[data-sss-arma-fee-price]").forEach(el => {
      el.textContent = data.fee.formattedPrice || "";
    });
    // Ask first at checkout, even if metadata needs review. All errors stay in this dialog.
    let requested = selectedChoice;
    const hasPanels = data.items.some(item => item.productId !== FEE_PRODUCT_ID && String(item.type).trim().toLowerCase() === 'solar panel');
    const saved = ['alberta','outside'].includes(data.attributes?.['ARMA destination']) && data.attributes?.['ARMA declaration version'] === '2026-10-v2' && !!data.attributes?.['ARMA answered at'];
    if (forceChoice && hasPanels && !requested && (changeChoice || !saved)) {
      requested = await ask(data.attributes?.['ARMA destination']);
      if (!requested) return {cancelled:true, changed:false};
    }
    const count = countPanels(data);
    let choice = requested || data.attributes?.['ARMA destination'] || '';
    if (!['alberta','outside'].includes(choice)) choice = '';
    latest = {count, choice}; paint();
    // First-time carts wait for checkout; never open a dialog on Add to Cart.
    if (count && !choice) return {changed:false};
    if (!count) choice = '';
    const fee = data.fee;
    if (count && (fee.productId !== FEE_PRODUCT_ID || fee.variantCount !== 1 || !fee.available || fee.requiresShipping || fee.taxable !== true || !Number.isSafeInteger(fee.price) || fee.price <= 0)) {
      throw new Error('The recycling fee product needs store setup. Please contact us before checkout.');
    }
    const desired = choice === 'alberta' ? count : 0;
    const feeLines = data.items.filter(item => item.productId === FEE_PRODUCT_ID);
    const canonical = feeLines.find(item => item.variantId === fee.variantId);
    const updates = {};
    for (const item of feeLines) {
      const quantity = item === canonical ? desired : 0;
      if (item.quantity !== quantity) updates[item.key] = quantity;
    }
    let changed = false;
    if (Object.keys(updates).length) {await json('cart/update.js', {updates}); changed = true;}
    if (desired && !canonical) {
      await json('cart/add.js', {items:[{id:fee.variantId, quantity:desired, properties:{_sss_arma_fee:'1'}}]});
      changed = true;
    }
    const attributes = {
      'ARMA destination':choice,
      'ARMA eligible panels':count ? String(count) : '',
      'ARMA fee status':count ? (choice === 'alberta' ? 'Applied — verify before release' : 'Outside Alberta declaration — verify shipment before release') : '',
      'ARMA declaration version':count ? '2026-10-v2' : '',
      'ARMA asked':count ? 'Yes' : '',
      'ARMA answered at':count ? (requested ? new Date().toISOString() : data.attributes?.['ARMA answered at'] || '') : ''
    };
    if (Object.entries(attributes).some(([key,value]) => (data.attributes?.[key] || '') !== value)) {
      await json('cart/update.js',{attributes}); changed = true;
    }
    // Read back the actual server cart. A Shopify quantity cap/discount must not be treated as success.
    const verified = await read();
    const verifiedFees = verified.items.filter(item => item.productId === FEE_PRODUCT_ID);
    if (countPanels(verified) !== count || verifiedFees.reduce((n,item)=>n+item.quantity,0) !== desired || verifiedFees.reduce((n,item)=>n+item.total,0) !== desired * fee.price) {
      throw new Error('The recycling fee could not be verified. Please review the cart or contact us before checkout.');
    }
    if (Object.entries(attributes).some(([key,value]) => (verified.attributes?.[key] || '') !== value)) throw new Error('Your delivery choice could not be saved. Please try again.');
    latest = {count, choice}; paint(); document.getElementById('sss-arma-error').hidden = true;
    return {changed};
  }
  async function mutate(url, options) {
    return serial(async () => {
      let response;
      try {
        response = await nativeFetch(url, options);
        if (!response.ok) return response;
        try {await sync();} catch (error) {report(error);}
        // Preserve add response; change callers need the cart AFTER the fee update.
        if (String(url).includes('/cart/change')) return new Response(JSON.stringify(await json('cart.js')), {status:200, headers:{'Content-Type':'application/json'}});
        return response;
      } catch (error) {
        report(error);
        return response || new Response(JSON.stringify({description:'Unable to update your cart. Please refresh and check it before trying again.'}), {status:503, headers:{'Content-Type':'application/json'}});
      }
    });
  }
  window.SSSArma = {mutate};
  async function review(force) {
    try {const result = await serial(() => sync(force)); refresh(result.changed);} catch (error) {report(error);}
  }
  document.addEventListener('cart:rerendered', paint);
  document.addEventListener('click', event => {
    if (event.target.closest('[data-sss-arma-change]')) {event.preventDefault(); checkout(null, true); return;}
    if (event.target.closest('[data-sss-arma-retry]')) {event.preventDefault(); review(false); return;}
    const link = event.target.closest('a[href]');
    const button = event.target.closest('[name="checkout"]');
    if (!button && !(link && new URL(link.href, location.href).pathname.match(/\/checkout\/?$/))) return;
    event.preventDefault(); event.stopImmediatePropagation(); checkout();
  }, true);
  document.addEventListener('submit', event => {
    if (event.submitter?.name === 'checkout' || (event.target.matches('form[action*="/cart"]') && !event.submitter && !event.target.matches('form[action*="/cart/add"]'))) {
      event.preventDefault(); event.stopImmediatePropagation(); checkout();
    }
  }, true);
  let checkingOut = false;
  async function checkout(selectedChoice = null, changeChoice = false) {
    if (checkingOut) return;
    checkingOut = true; checkoutMode = true;
    const button = document.getElementById('sss-arma-confirm');
    try {
      const result = await serial(() => sync(true, selectedChoice, changeChoice));
      if (result.cancelled) return;
      button.disabled = true; button.textContent = 'Opening checkout…';
      window.location.assign(root + 'checkout');
    } catch (error) {report(error);}
    finally {checkoutMode = false; checkingOut = false; button.disabled = false; button.textContent = 'Continue to checkout';}

  }
  // Restore saved carts and remove orphaned fee lines. No cookies/localStorage required.
  serial(() => sync()).then(result => {if (result.changed) refresh();}).catch(report);
  window.addEventListener('pageshow', event => {if (event.persisted) review(false);});
})();
